import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { RCIPInspectionRequestVM } from '../../../../data/models/coverage-validator-api-models';
import { ButtonComponent, CardComponent } from '../../../../ui-common';
import { splitStatement } from '../rcip-wizard.helpers';

@Component({
  selector: 'app-rcip-eligibility',
  templateUrl: './rcip-eligibility.html',
  styleUrl: './rcip-eligibility.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, CardComponent],
})
export class RcipEligibility {
  request = input.required<RCIPInspectionRequestVM>();
  back = output<void>();
  next = output<void>();

  protected sections = computed(() =>
    (this.request().eligibilityStatements?.programStatementSections ?? []).map((s) =>
      splitStatement(s.statement),
    ),
  );
}
